import { InViewport } from "@gik/core/components/InViewport";
import { ErrorPageSection } from "@gik/core/pages/Error/ErrorPageSection";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { CreateClickedLocation } from "@gik/create/enums/CreateAnalyticsEnums";
import { PageHeader } from "@gik/ui-legacy/gik/PageHeader";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import { StartInkindCard } from "@gik/ui-legacy/gik/StartInkindCard";
import { TestimonialsCarouselSection } from "@gik/ui-legacy/gik/TestimonialsCarouselSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import { CompetitorsComparisonTable } from "../../components/CompetitorsComparisonTable";
import { MarketingNavSection } from "../../components/MarketingNav";
import { translationKeys } from "./i18n/en";

export const CompetitorsPageBlockName = "competitors-page";

function CompetitorsPageComp(): React.ReactElement {
	const bem = bemBlock(CompetitorsPageBlockName);
	const { t } = useTranslation();

	return (
		<div className={bem()}>
			{/* <StickyHorizontal> */}
			<PageHeader decoration="foliage" variant="warm">
				<h1>{t(translationKeys.title)}</h1>
			</PageHeader>
			<PageSection className={bem("lead")} noPadBottom>
				<p className="gik-section-lead">{t(translationKeys.leadDescription)}</p>
			</PageSection>
			{/* </StickyHorizontal>  */}

			<InViewport height={1286}>
				<PageSection
					contained={false}
					className="gik-competitors-comparison-section"
				>
					<CompetitorsComparisonTable />
				</PageSection>
			</InViewport>

			{/* <StickyHorizontal> */}
			<InViewport height={175}>
				<StartInkindCard trackingId={CreateClickedLocation.COMPETITORS_PAGE} />
			</InViewport>
			<InViewport height={394}>
				<TestimonialsCarouselSection />
			</InViewport>
			<InViewport height={461}>
				<MarketingNavSection variant="warm" />
			</InViewport>
			{/* </StickyHorizontal> */}
		</div>
	);
}

export const CompetitorsPage = withComponentErrorBoundary(CompetitorsPageComp, {
	ErrorFallback: ErrorPageSection,
});
